import styled from "styled-components";
const MenuWrapper = styled("div")``;
export {
  MenuWrapper
};
